import * as types from './types';

const INITIAL_STATE = {
  columns: null,
  data: null,
  loading: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GENERAL_REPORT_ARCHETYPE_FETCH_SUCCESS: {
      return {
        ...state,
        columns: action.payload.columns
      };
    }
    case types.GENERAL_REPORT_DATA_FETCH_START: {
      return {
        ...state,
        loading: true
      };
    }
    case types.GENERAL_REPORT_DATA_FETCH_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};
